import React from 'react'

   export const defaultOverviewEAdhigam = {
          Eadhigam_students_week_four: 0,
          Eadhigam_students_week_one: 0,
          Eadhigam_students_week_three: 0,
          Eadhigam_students_week_two: 0,
        }
    
    export const DefaultEAdhigamTeacher ={
      week_four: 0,
      week_one: 0,
      week_three: 0,
      week_two: 0
    }
    export const DefaultTeacherOnStudentMonitoring ={
      week_four: 0,
      week_one: 0,
      week_three: 0,
      week_two: 0
    }

    export const defaultDetailedStudent = {
        AverageWeeklRemedialAttempted: {
          week_four: {
            10: 0,
            11: 0,
            12: 0,
          },
          week_one: {
            10: 0,
            11: 0,
            12: 0,
          },
          week_three: {
            10: 0,
            11: 0,
            12: 0,
          },
          week_two: {
            10: 0,
            11: 0,
            12: 0,
          }
        },
        averageWeeklyHomeworkAttempted: {
          week_four: {
            10: 0,
            11: 0,
            12: 0,
          },
          week_one: {
            10: 0,
            11: 0,
            12: 0,
          },
          week_three: {
            10: 0,
            11: 0,
            12: 0,
          },
          week_two: {
            10: 0,
            11: 0,
            12: 0,
          }
        },
        averageWeeklyPALUsagebyStudentsInMin: {
          week_four: {
            10: 0,
            11: 0,
            12: 0,
          },
          week_one: {
            10: 0,
            11: 0,
            12: 0,
          },
          week_three: {
            10: 0,
            11: 0,
            12: 0,
          },
          week_two: {
            10: 0,
            11: 0,
            12: 0,
          }
        }
      } 
    export   const defaultDetailedTeacher ={   
        Avarage_home_work_assigned: {
          week_four: 0,
          week_one: 0,
          week_three: 0,
          week_two: 0
        },
        Avarage_weekly_usage: {
          week_four: 0,
          week_one: 0,
          week_three: 0,
          week_two: 0
        },
        eadhigam_teacher: {
          week_four: 0,
          week_one: 0,
          week_three: 0,
          week_two: 0
        },
        monitaring:
        {
          week_four: 0,
          week_one: 0,
          week_three: 0,
          week_two: 0
        },
        Teachers_who_have_assigned_atleast_1_homework: 0,
        Total_Teacher_Strength_PAL: 0,
        students_who_have_assigned_atleast_1_diagnostic_test_group: {
          10: 0,
          11: 0,
          12: 0
        }
      }

      export const defaultDetailedEAdhigamStudent = {
        Eadhigam : {
          week_four: {
            10: 0,
            11: 0,
            12: 0
          },
          week_one: {
            10: 0,
              11: 0,
              12: 0
            },
            week_three: {
              10: 0,
              11: 0,
              12: 0
            },
            week_two: {
              10: 0,
              11: 0,
              12: 0
            }
          }
        }

      export const defALlSchoolEAdhigamForProgress =[{
        "School": "",
        "school_code": "",
        "student": {
            "week_four": {
                "%_eadhigam_student": 0,
                "total_eadhigam_student": 0
            },
            "week_one": {
                "%_eadhigam_student": 0,
                "total_eadhigam_student": 0
            },
            "week_three": {
                "%_eadhigam_student": 0,
                "total_eadhigam_student": 0
            },
            "week_two": {
                "%_eadhigam_student": 0,
                "total_eadhigam_student": 0
            }
        },
        "teacher": {
            "week_four": {
                "%_eadhigam_teacher": 0,
                "total_eadhigam_teacher": 0
            },
            "week_one": {
                "%_eadhigam_teacher": 0,
                "total_eadhigam_teacher": 0
            },
            "week_three": {
                "%_eadhigam_teacher": 0,
                "total_eadhigam_teacher": 0
            },
            "week_two": {
                "%_eadhigam_teacher": 0,
                "total_eadhigam_teacher": 0
            }
        }
    }]

    export const defAllBlockEAdhigamForProgress =[{
      "Block": "",
      "student": {
          "week_four": {
              "%_eadhigam_student": 0,
              "total_eadhigam_student": 0
          },
          "week_one": {
              "%_eadhigam_student": 0,
              "total_eadhigam_student": 0
          },
          "week_three": {
              "%_eadhigam_student": 0,
              "total_eadhigam_student": 0
          },
          "week_two": {
              "%_eadhigam_student": 0,
              "total_eadhigam_student": 0
          }
      },
      "teacher": {
          "week_four": {
              "%_eadhigam_teacher": 0,
              "total_eadhigam_teacher": 0
          },
          "week_one": {
              "%_eadhigam_teacher": 0,
              "total_eadhigam_teacher": 0
          },
          "week_three": {
              "%_eadhigam_teacher": 0,
              "total_eadhigam_teacher": 0
          },
          "week_two": {
              "%_eadhigam_teacher": 0,
              "total_eadhigam_teacher": 0
          }
      }
  }]